import { useCallback, useState } from 'react';

const closedState = {
  isOpen: false,
  context: null,
  initialRecipients: { to: '', bcc: '' },
  initialTemplate: 'custom',
  initialSubject: '',
  initialBody: '',
};

/**
 * Shared state for {@link EmailComposerModal}. Pass `emailComposerProps` plus `onEmailSent` (if needed) to the modal.
 */
export function useEmailComposer() {
  const [composer, setComposer] = useState(closedState);

  const openEmailComposer = useCallback((config = {}) => {
    const to = config.to ?? config.initialRecipients?.to ?? '';
    const bcc = config.bcc ?? config.initialRecipients?.bcc ?? '';
    setComposer({
      isOpen: true,
      context: config.context ?? null,
      initialRecipients: config.initialRecipients || { to, bcc },
      initialTemplate: config.template || config.initialTemplate || 'custom',
      initialSubject: config.initialSubject ?? config.subject ?? '',
      initialBody: config.initialBody ?? config.body ?? '',
    });
  }, []);

  const closeEmailComposer = useCallback(() => {
    setComposer((c) => ({ ...c, isOpen: false }));
  }, []);

  return {
    emailComposerProps: {
      isOpen: composer.isOpen,
      onClose: closeEmailComposer,
      context: composer.context,
      initialRecipients: composer.initialRecipients,
      initialTemplate: composer.initialTemplate,
      initialSubject: composer.initialSubject,
      initialBody: composer.initialBody,
    },
    openEmailComposer,
    closeEmailComposer,
  };
}
